import { normalizeApiError, ykApiClient } from './apiClient';

export async function verifyRecaptcha({ token }) {
  try {
    const res = await ykApiClient.post('/ykrestapi/PaymentChannel/verify-recaptcha', {
      token,
    });
    return res?.data;
  } catch (e) {
    throw normalizeApiError(e);
  }
}

export async function createAuthNetRecurringPayment(payload) {
  try {
    const res = await ykApiClient.post(
      '/ykrestapi/PaymentChannel/AuthNetRecurringPayment',
      payload
    );
    return res?.data;
  } catch (e) {
    throw normalizeApiError(e);
  }
}
